import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const MAIN_HOSTS = ["click2crm.it", "www.click2crm.it", "corsando.net", "www.corsando.net", "localhost", (() => { try { return new URL(ENV_URL).hostname; } catch (e) { return ""; } })()];
export const IS_PARTNER_DOMAIN = typeof window !== "undefined" && !MAIN_HOSTS.includes(window.location.hostname);
// partner domains point at the same server: call the API on the same origin so auth cookies stay first-party
const ENV_HOST = (() => { try { return new URL(ENV_URL).hostname; } catch (e) { return ""; } })();
const SAME_ORIGIN = typeof window !== "undefined" && !["localhost", ENV_HOST].includes(window.location.hostname);
const BACKEND_URL = SAME_ORIGIN ? window.location.origin : ENV_URL;
export const API = `${BACKEND_URL}/api`;
(() => {
  if (typeof window === "undefined") return;
  const q = new URLSearchParams(window.location.search).get("shop");
  if (q === "off") localStorage.removeItem("cs_shop");
  else if (q) localStorage.setItem("cs_shop", q.toUpperCase());
})();
export const SHOP_CODE = typeof window !== "undefined" ? localStorage.getItem("cs_shop") : null;
export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const api = axios.create({ baseURL: API, withCredentials: true });
if (SHOP_CODE) api.defaults.headers.common["X-Shop"] = SHOP_CODE;
if (IS_PARTNER_DOMAIN) api.defaults.headers.common["X-Shop-Host"] = window.location.hostname;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
